export enum MessageType {
  LOGIN = 1,
  PARAMETERS = 2,
  PARAMETERS_ACK = 3,
  PROGRESSIVE_CUR_VALUES = 4,
  PROGRESSIVE_CUR_VALUES_ACK = 6,
  JACKPOT_HIT = 5,
  JACKPOT_HIT_ACK = 7,
  JACKPOT_HISTORY = 8,
  JACKPOT_HISTORY_ACK = 9,
}

export enum DisplayMode {
  NO_CENTS = 1,
  CENTS = 2,
}

export type LoginMessage = {
  msgType: MessageType.LOGIN;
  signId: string;
};

export type ParametersMessage = {
  msgType: MessageType.PARAMETERS;
  eventId: string;
  mode?: DisplayMode;
  values?: { id: number; jp: number }[];
};

export type ParametersAckMessage = {
  msgType: MessageType.PARAMETERS_ACK;
  eventId: string;
  signId: string;
};

export type ProgressiveCurValuesMessage = {
  msgType: MessageType.PROGRESSIVE_CUR_VALUES;
  values: { code: number; value: number }[];
};

export type ProgressiveCurValuesAckMessage = {
  msgType: MessageType.PROGRESSIVE_CUR_VALUES_ACK;
  timestamp: number;
  signId: string;
};

/** Jackpot hit params used in JACKPOT_HIT and history entries */
export type JackpotHitParams = {
  jp: number; // jackpot identifier
  name: string; // jackpot name
  mach_id: number; // machine id where jackpot hit
  timestamp: string; // ISO timestamp string
  value: number; // integer value (in cents)
  location?: string; // optional location string
};

export type JackpotHitMessage = {
  msgType: MessageType.JACKPOT_HIT;
  eventId: string;
  params: JackpotHitParams;
};

export type JackpotHitAckMessage = {
  msgType: MessageType.JACKPOT_HIT_ACK;
  eventId: string;
  signId: string;
};

export type JackpotHistoryMessage = {
  msgType: MessageType.JACKPOT_HISTORY;
  eventId: string;
  signId: string;
  values: {
    jp: number;
    name: string;
    mach_id: number;
    timestamp: string;
    value: number;
    location: string;
  }[];
};

export type JackpotHistoryAckMessage = {
  msgType: MessageType.JACKPOT_HISTORY_ACK;
  eventId: string;
  signId: string;
};

export type WebSocketMessage =
  | LoginMessage
  | ParametersMessage
  | ParametersAckMessage
  | ProgressiveCurValuesMessage
  | ProgressiveCurValuesAckMessage
  | JackpotHitMessage
  | JackpotHitAckMessage
  | JackpotHistoryMessage
  | JackpotHistoryAckMessage;

export interface SignErrorResponse {
  error: true;
  reason: string;
}
